// ============================================================
// 管理端路由实例
// 用户详情走 GET /manage/user/info，菜单走 GET /manage/menus
// ============================================================
import { createDynamicRouter } from "@shared/router";
import Layout from "@shared/layout/index.vue";
import { fetchCurrentUserInfo, fetchCurrentUserMenus } from "@app/api/user";
import { useCurrentUserStore } from "@app/store/modules/currentUser";
import { staticRoutes } from "./routes";

/**
 * 顶栏 InSiteMessageDrawer / 站内信详情页的「去处理」/「查看全部」等入口，
 * 与权限 / 动态菜单无关，必须始终可访问：
 */
const guaranteedRoutes = [
    {
        path: "/inSiteMessage",
        component: Layout,
        meta: { hidden: true },
        children: [
            {
                path: "list",
                name: "InSiteMessageList",
                component: () => import("@app/views/inSiteMessage/list/index.vue"),
                meta: { title: "消息列表", hidden: true },
            },
            {
                path: "detail",
                name: "InSiteMessageDetail",
                component: () => import("@app/views/inSiteMessage/detail/index.vue"),
                meta: { title: "消息详情", hidden: true },
            },
        ],
    },
];

const router = createDynamicRouter({
    staticRoutes,
    guaranteedRoutes,
    fetchUserMenus: async () => {
        const data = await fetchCurrentUserInfo();
        const currentUser = useCurrentUserStore();
        currentUser.hydrateFromInfo(data);
        const items = await fetchCurrentUserMenus();
        currentUser.setMenus(items);
        return items;
    },
    layout: Layout,
    whiteList: ["/login", "/404", "/403"],
    baseTitle: import.meta.env.VITE_APP_TITLE || "1P管理端",
    loginPage: () => import("@app/views/login.vue"),
    requireAuth: true,
});

export default router;
